import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import NewUserNotification from '../components';

const mapStateToProps = state => ({
  literals: state.i18n.literals.notificationsModal,
  actualUser: state.session.user,
});

function mapDispatchToProps() {
  return {};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewUserNotification));



// WEBPACK FOOTER //
// ./src/components/NotificationsTypes/NewUserConnection/container/index.js